@if (visible()) {
  <section class="sanofi-infoBanner sanofi-infoBanner--orderCappingLimitReached py-3 px-3 my-3 d-flex">
    <cx-icon class="sanofi-infoBanner__warningIcon align-self-start pr-2" [type]="iconTypes.WARNING"/>
    <div class="sanofi-infoBanner__content">
      <p class="w-100 mb-0">
        {{ 'addToCartItems.orderCappingLimitReachedBannerText' | cxTranslate }}
      </p>
    </div>
    <div class="d-flex lign-self-center flex-fill justify-content-end">
      <button aria-label="close"
              tabindex="0"
              role="button"
              aria-pressed="false"
              class="sanofi-infoBanner__closeIconButton"
              (click)="visible.set(false)"
      >
        <cx-icon class="sanofi-infoBanner__closeIcon" [type]="iconTypes.CLOSE"/>
      </button>
    </div>
  </section>
}
